// Number Base Converter Tool — binary / octal / decimal / hex conversion.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const numberBaseTool: Tool = {
  id: "number-base",
  name: () => m.nb_tool_name(),
  description: () => m.nb_tool_description(),
  icon: "🔢",
  basePath: "/number-base",
  status: "stable",
  tags: ["binary", "hex", "base", "developer"],
  pages: [
    {
      name: () => m.nb_nav_main(),
      path: "/number-base",
      description: () => m.nb_nav_main_desc(),
      icon: "🔢",
    },
  ],
};
